import { Component, Inject, OnInit } from '@angular/core';
import { INotifyTemplate } from '../models/notify-template.interface';
import * as _ from 'lodash';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'upsc-notify-template-form-dialog',
  templateUrl: './notify-template-form-dialog.component.html',
  styleUrls: ['./notify-template-form-dialog.component.scss'],
})
export class NotifyTemplateFormDialogComponent implements OnInit {
  public template: INotifyTemplate;
  public templateTitle = 'Template Preview';
  public sessionLanguage : string;

  constructor(public dialogRef: MatDialogRef<NotifyTemplateFormDialogComponent>, 
              @Inject(MAT_DIALOG_DATA) public data: any,
              private translate: TranslateService) {
      this.translate.onLangChange.subscribe((event) => {
        this.sessionLanguage = event.lang.toUpperCase();
        this.templateTitle = this.changeTemplateTitle();
    })
  }

  public ngOnInit() {
    this.sessionLanguage = sessionStorage.getItem('lang').toUpperCase();
    this.templateTitle = this.changeTemplateTitle();
  }

  public onFormValuesChanged(template: INotifyTemplate) {
    this.template = _.cloneDeep(template);
    this.templateTitle = template.TemplateName || this.changeTemplateTitle();
  }

  public onTemplateCreated(template: INotifyTemplate) {
    this.dialogRef.close(template);
  }
  public changeTemplateTitle(){
    switch(this.sessionLanguage){
      case 'FR':
        this.templateTitle = 'Aperçu du modèle';
        break;
      case 'DE':
        this.templateTitle = 'Vorlage Vorschau';
        break;
      case 'IT':
        this.templateTitle = 'Anteprima del modello';
        break;
      default:
        this.templateTitle = 'Template Preview';
        break;
    }
    return this.templateTitle;
  }
}
